<template>
  <div id="System" class="system">
    <div class="system-background">
      <!-- <div class="system-corner" /> -->
      <v-img class="system-title" src="../assets/img/system-title.png" />
      <v-img class="system-img1" src="../assets/img/top-system-present.png" />
      <v-img class="system-img2" src="../assets/img/item-Cosmetics.png" />
      <v-img class="system-img3" src="../assets/img/item-Hairband.png" />
      <v-img class="system-img4" src="../assets/img/system-img.png" />
      <div class="system-text">
        <p class="system-text-title">〜遊び方〜</p>
        <p class="system-text-1">
          女の子に<br />
          <span style="color: #ff8ba9">プレゼント</span>を渡して<br />
          仲良くなろう！<br /><br />
          プレゼントの内容に応じて<br />
          <span style="color: #6aa8f5">好感度の上昇度が変化。</span><br /><br />
          こまめにプレゼントをあげると<br />
          <span style="color: #f51e68">早く仲良く</span>なれるかも！？<br />
        </p>
        <p class="system-text-2">
          ボイスは全てフルボイス！<br />
          時間帯や好感度に応じて変化。<br />
          <span style="color: #8b3ecc">意地悪なセリフ</span>もあれば<br />
          <span style="color: #ff94c6">褒めてくれる</span>ことも…！<br />
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SystemView',
};
</script>

<style lang="scss" scoped>
.system {
  position: relative;
  background: url(../assets/img/background.png) repeat-y;
  background-size: 200% auto;
  background-attachment: fixed;
  font: 5vw 'ヒラギノ丸ゴ Pro W4', 'ヒラギノ丸ゴ Pro', 'Hiragino Maru Gothic Pro';
  text-shadow: 0px 0px 1px white;
  color: #919191;
  font-weight: bold;
  width: 100%;
  @media screen and (min-width: 960px) {
    background-size: 100% auto;
    font-size: 2vw;
  }
  line-height: 1.7em;
  &-background {
    padding: 20% 0 10%;
    background-color: rgba(255, 255, 255, 0.75);
    @media screen and (min-width: 960px) {
      padding: 10% 0 10%;
    }
  }
  &-title {
    margin: 7% auto;
    width: 60%;
    @media screen and (min-width: 960px) {
      width: 30%;
      margin: 5% auto 10%;
    }
  }
  &-img1 {
    position: absolute;
    width: 70%;
    top: 28%;
    right: 50%;
    transform: rotateZ(-15deg);
    opacity: 0.2;
    @media screen and (min-width: 960px) {
      width: 28%;
      top: 58%;
      right: 62%;
    }
  }
  &-img2 {
    position: absolute;
    width: 55%;
    top: 41%;
    left: -10%;
    opacity: 0.3;
    @media screen and (min-width: 960px) {
      width: 13%;
      top: 58%;
      left: auto;
      right: 68%;
      opacity: 1;
      transform: rotateZ(-20deg);
      z-index: 1;
    }
  }
  &-img3 {
    position: absolute;
    width: 38%;
    top: 44%;
    right: 29%;
    transform: rotateZ(15deg);
    opacity: 0.3;
    @media screen and (min-width: 960px) {
      width: 10%;
      top: 36%;
      right: 50%;
      opacity: 1;
      z-index: 1;
    }
  }
  &-img4 {
    position: absolute;
    display: inline-block;
    width: 75%;
    top: 68%;
    right: 24px;
    @media screen and (min-width: 960px) {
      width: 25%;
      top: 40%;
      right: 53%;
    }
  }
  &-text {
    text-shadow: 1.5px 1.5px 1px #fff, -1.5px -1.5px 1px #fff, -1.5px 1.5px 1px #fff, 1.5px -1.5px 1px #fff,
      1.5px 0px 1px #fff, -1.5px -0px 1px #fff, 0px 1.5px 1px #fff, 0px -1.5px 1px #fff;
    padding: 0 0 40%;
    transform: scale(1);
    @media screen and (min-width: 960px) {
      width: 35%;
      padding: 0;
      margin: 0 0 0 50%;
    }

    &-title {
      font-size: 8vw;
      text-align: center;

      width: 100%;
      margin: 10% auto 12%;
      @media screen and (min-width: 960px) {
        width: 40%;
        font-size: 2.3vw;
        margin: 10% 43% 12% auto;
      }
    }
    &-1 {
      width: 100%;
      padding: 0 0 25% 27%;
      letter-spacing: -1.5px;
      @media screen and (min-width: 960px) {
        text-align: left;
        padding: 0 0 5% 7%;
      }
    }
    &-2 {
      padding: 0 0 30% 24px;
      letter-spacing: -1.5px;
      @media screen and (min-width: 960px) {
        text-align: left;
        padding: 0 0 0 7%;
      }
    }
  }
}
</style>
